import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AnalyticsTrendDirection } from 'core/types/my-forest-analytics.interface';

@Component({
  selector: 'app-analytics-trend-icon',
  template: `
    @if (direction() === 'flat') {
      <svg class="block size-full" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M4 12H20M20 12L15.5 7.5M20 12L15.5 16.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    } @else {
      <svg
        class="block size-full"
        [class.-scale-y-100]="direction() === 'down'"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M13.7489 6L21.3027 6.00052L21.403 6.01444L21.5018 6.04205L21.5621 6.0676C21.6413 6.10246 21.7155 6.15315 21.7808 6.21836L21.8215 6.2624L21.865 6.31878L21.9192 6.4089L21.9579 6.49922L21.977 6.5633L21.9906 6.6273L22 6.7215L22.0004 14.2539C22.0004 14.6681 21.6647 15.0039 21.2504 15.0039C20.8708 15.0039 20.557 14.7217 20.5073 14.3557L20.5004 14.2539L20.5 8.559L12.7812 16.2793C12.5149 16.5455 12.0982 16.5698 11.8046 16.3519L11.7205 16.2793L8.75001 13.3089L3.28033 18.7786C2.98744 19.0715 2.51256 19.0715 2.21967 18.7786C1.9534 18.5123 1.9292 18.0957 2.14705 17.8021L2.21967 17.7179L8.21967 11.7179C8.48593 11.4517 8.90259 11.4275 9.1962 11.6453L9.28032 11.7179L12.2508 14.6883L19.438 7.5H13.7489C13.3692 7.5 13.0554 7.21785 13.0058 6.85177L12.9989 6.75C12.9989 6.3703 13.2811 6.05651 13.6472 6.00685L13.7489 6Z"
          fill="currentColor"
        />
      </svg>
    }
  `,
  host: {
    class: 'inline-block size-6 overflow-hidden',
    '[attr.role]': "decorative() ? null : 'img'",
    '[attr.aria-label]': 'decorative() ? null : label()',
    '[attr.aria-hidden]': "decorative() ? 'true' : null"
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnalyticsTrendIconComponent {
  readonly direction = input.required<AnalyticsTrendDirection>();
  readonly label = input<string>();
  readonly decorative = input(false);
}
